<template>
  <div>
    <b-modal id="modalEditIndependentServicesConnect" ref="modalEditIndependentServicesConnect" @shown="shown"
      :title="$t('Services and tariffs connect')" hide-footer>
      <div  v-if="editItem">
        <b-form-group label-align="right" v-if="editItem.id != 0" disabled label="ID" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.id" disabled/>
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.group_id" :options="groups" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Name')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-input v-model="editItem.name" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Service')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select @change="changeService" v-model="editItem.service_id" :options="templateServices" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Tariff')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select @change="changeTariff" v-model="editItem.tariff_id" :options="tariffs" />
        </b-form-group>
        <b-form-group label-align="right" :disabled="editItem.id != 0" :label="$t('Accounting period')" label-cols="4" label-cols-xl="4" label-cols-md="4">
          <b-form-select v-model="editItem.accounting_period_id" :options="accountingPeriods" :disabled="editItem.id != 0"/>
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Active')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox v-model="editItem.is_enabled" value="1" unchecked-value="0" />
        </b-form-group>
        <b-form-group label-align="right" :label="$t('Allow multiple linking')" label-cols="4" label-cols-xl="4" label-cols-md="4">
           <b-form-checkbox v-model="editItem.multiple_linking" value="1" unchecked-value="0" />
        </b-form-group>
        <b-row>
          <b-col>
            <b-button class="mt-3" variant="success" style="float: right; width: 100px" @click="save">{{ $t('Save')}}</b-button>
          </b-col>
          <b-col sm="1.5">
            <b-button class="mt-3" variant="secondary" style="float: right; width: 100px" @click.stop="$refs.modalEditIndependentServicesConnect.hide">{{ $t('Cancel') }}</b-button>
          </b-col>
        </b-row>
      </div>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    editItem: null
  },
  methods: {
    changeService () {
      if (this.editItem.service_id !== 0) {
        this.editItem.tariff_id = 0
      }
    },
    changeTariff () {
      if (this.editItem.tariff_id !== 0) {
        this.editItem.service_id = 0
      }
    },
    save () {
      let response = this.editItem.id !== 0
        ? this.$store.dispatch('Settings/UPDATE_INDEPENDENT_SERVICES_CONNECT', this.editItem)
        : this.$store.dispatch('Settings/CREATE_INDEPENDENT_SERVICES_CONNECT', this.editItem)
      response.then(response => {
        if (response.data.error) {
          this.$root.$emit('makeToasts', 'danger', response.data.error, 'Error')
        } else {
          setTimeout(this.$store.dispatch, 500, 'Settings/GET_INDEPENDENT_SERVICES_CONNECT')
          this.$refs.modalEditIndependentServicesConnect.hide()
          this.$root.$emit('makeToasts')
        }
      })
    },
    shown () {
      if (this.editItem.id === 0 && this.groups.length) {
        this.editItem.group_id = this.groups[0].value
      }
    }
  },
  computed: {
    groups () {
      let res = []
      res.push({value: 0, text: this.$t('All')})
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {}
        newEl.value = el.group_id
        newEl.text = el.group_name
        res.push(newEl)
      }
      return res
    },
    independentServicesConnect () {
      return this.$store.getters['Settings/INDEPENDENT_SERVICES_CONNECT']
    },
    services () {
      return this.$store.getters['Tariffing/SERVICES']
    },
    accountingPeriods () {
      let res = []
      for (let el of this.$store.getters['Tariffing/ACCOUNTING_PERIODS']) {
        if (el.id === 1) {
          continue
        }
        let newEl = {}
        newEl.value = el.static_id
        let accPeriodName = ''
        switch (el.periodic_type) {
          case 1:
            accPeriodName = this.$i18n.t('Daily')
            break
          case 2:
            accPeriodName = this.$i18n.t('Weekly')
            break
          case 3:
            accPeriodName = this.$i18n.t('Monthly')
            break
          case 4:
            accPeriodName = this.$i18n.t('Quarterly')
            break
          case 5:
            accPeriodName = this.$i18n.t('Annual')
            break
          default:
            accPeriodName = this.$i18n.t('CustomDuration')
            break
        }
        newEl.text = el.id + ' (' + moment(Number(el.begin) * 1000).format('DD-MM-YYYY') + '-' + moment(Number(el.end) * 1000).format('DD-MM-YYYY') + ') ' + accPeriodName
        res.push(newEl)
      }
      return res
    },
    tariffs () {
      let res = []
      res.push({value: 0, text: this.$t('Disabled')})
      for (let el of this.$store.getters['Tariffing/TARIFFS']) {
        if (el.id === 0) {
          continue
        }
        let newEl = {}
        newEl.value = el.id
        newEl.text = el.name
        res.push(newEl)
      }
      return res
    },
    templateServices () {
      let templateServices = this.services
      templateServices = templateServices.filter(function (value) {
        return value.parent_id === 0 && value.tariff_id === 0
      })
      let res = []
      res.push({value: 0, text: this.$t('Disabled')})
      for (let el of templateServices) {
        if (!([1, 2, 8, 9].includes(el.service_type))) {
          continue
        }
        let newEl = {}
        newEl.value = el.service_id
        newEl.text = el.service_name
        res.push(newEl)
      }
      return res
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/settings/customerPortal/customerIndependentServiceConnect/editModal.vue